import React from 'react';

/** 支付配置 Form：关闭浏览器自动填充 */
export const PAYMENT_FORM_AUTO_COMPLETE = 'off';

/** 支付配置普通输入：关闭自动填充 */
export const PAYMENT_INPUT_AUTO_COMPLETE = 'off';

/**
 * 密码框用 new-password。Chrome 会忽略 password 框上的 off，
 * 并可能把邻近文本框当成用户名一起填入。
 */
export const PAYMENT_PASSWORD_AUTO_COMPLETE = 'new-password';

/**
 * 吸收浏览器对用户名/密码的自动填充，避免写入真实业务字段。
 * 不能用 display:none，否则密码管理器会跳过并继续填充可见输入框。
 */
export const PaymentFormAutofillGuard: React.FC = () => (
  <div
    aria-hidden="true"
    style={{
      position: 'absolute',
      left: -9999,
      width: 1,
      height: 1,
      overflow: 'hidden',
      opacity: 0,
    }}
  >
    <input type="text" tabIndex={-1} autoComplete="username" />
    <input type="password" tabIndex={-1} autoComplete="current-password" />
  </div>
);
